import "../main.css";

export default function PalavraChaveRfv() {
  return (
    <div>
      <ul
        className="nav categories-nav nav-pills flex-column"
        role="navigation"
      >
        <li className="nav-item open">
          <h4>Palavras-chave</h4>

          <div style={{ paddingTop: "6px" }}>
            <ul className="nav nav-pills flex-column">
              <li className="keypass-container">
                <a
                  className=" keypass"
                  href="/entendendo-o-rfv-recencia-frequencia-e-valor#campeao"
                >
                  campeão
                </a>
                <a
                  className="keypass"
                  href="/entendendo-o-rfv-recencia-frequencia-e-valor#fieis"
                >
                  consumidor leal
                </a>
                <a
                  className="keypass"
                  href="/entendendo-o-rfv-recencia-frequencia-e-valor#lealdade"
                >
                  lealdade em potencial
                </a>
                <a
                  className="keypass"
                  href="/entendendo-o-rfv-recencia-frequencia-e-valor#novos"
                >
                  novos consumidores
                </a>
                <a
                  className="keypass"
                  href="/entendendo-o-rfv-recencia-frequencia-e-valor#promissores"
                >
                  promissores
                </a>
                <a
                  className="keypass"
                  href="/entendendo-o-rfv-recencia-frequencia-e-valor#atencao"
                >
                  atenção
                </a>
                <a
                  className="keypass"
                  href="/entendendo-o-rfv-recencia-frequencia-e-valor#fugir"
                >
                  prestes a fugir
                </a>
                <a
                  className="keypass"
                  href="/entendendo-o-rfv-recencia-frequencia-e-valor#perder"
                >
                  não podemos perdê-los
                </a>
                <a
                  className="keypass"
                  href="/entendendo-o-rfv-recencia-frequencia-e-valor#risco"
                >
                  em risco
                </a>
                <a
                  className="keypass"
                  href="/entendendo-o-rfv-recencia-frequencia-e-valor#hibernando"
                >
                  hibernando
                </a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  );
}
